const camelize = require('underscore.string/camelize')
const $ = require('jquery')

const View = require('public_framework/view')

const share = require('social_share')
const {formatNumber, getSharesNoun} = require('shared/javascripts/string_utils')
const SocialShareCounter = require('social_share_counter').default
const locationWrap = require('shared/javascripts/location_wrap')

const openWindow = (url) => window.open(url)

class SocialShareView extends View {
  constructor (args) {
    super(args)

    const data = this.$el.data()

    this.url = data.url
    this.title = data.title
    this.text = data.text
    this.hashtags = data.hashtags
    this.rssUrl = data.rssUrl
    this.youtubeChannelUrl = data.youtubeChannelUrl
    this.utm = data.utm

    if (!this.title) { this.title = $('head title').text() }
    this.isUrlFixed = !!this.url
    if (!this.url) { this.url = locationWrap.href().replace(/#$/, '') }

    if (this._withUtmParams()) {
      this.url += window.location.search.length > 0 ? `&${this.utm}` : `?${this.utm}`
    }

    if (this._withCounter()) {
      this.counter = SocialShareCounter.forURL(this.url, window.gon.url_share_counter)
      this.counter.onChange(data => this.setCounter(data))
    }

    this.splitUrl = this.url.split('#')
  }

  get events () {
    return {
      'click @link': 'handleClick'
    }
  }

  get els () {
    return {
      $counterNum: '@counter_num',
      $counterText: '@counter_text'
    }
  }

  handleClick (e) {
    e.preventDefault()

    const type = $(e.currentTarget).data('type')
    switch (type) {
      case 'rss_follow':
        return openWindow(this.rssUrl)
      case 'youtube':
        return openWindow(this.youtubeChannelUrl)
      default:
        var fragment = this.isUrlFixed ? (this.splitUrl[1] || '') : locationWrap.hash().substring(1)
        var urlToShare = this.splitUrl[0]
        if (fragment) { urlToShare += `#${fragment}` }
        this.showShare(urlToShare, type)
    }
  }

  showShare (url, type) {
    share(url, {
      target: type,
      title: this.title,
      text: this.text,
      hashtags: this.hashtags
    }).then(() => {
      if (this._withCounter()) this.counter.increase(camelize(type))
    }).catch(() => {
      this.emit('notifications:notice', `Pop-up blocked. <a target="_blank" href="${url}">Share on social media.</a>`, { delay: 15000 })
    })
  }

  setCounter (total) {
    this.$counterNum().text(formatNumber(total))
    this.$counterText().text(getSharesNoun(total))
    this.$el.addClass('is-loaded')
  }

  _withCounter () {
    const counterNumElements = this.$counterNum() || []
    return counterNumElements.length > 0
  }

  _withUtmParams () {
    return (this.utm != null ? this.utm.length : undefined) > 0
  }
}

module.exports = SocialShareView



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/social_share/views/social_share.js